/**
 * SALVIA-938 — quantidade de itens do card, para o contador das caixas
 * laterais da consulta (visível com a caixa fechada).
 *
 * Conta TODOS os itens que o card mostra: os lançados à mão e os vindos de
 * proposta aprovada da IA (salvia-840) — o número bate com o que se vê ao
 * abrir a caixa.
 *
 * O card que usar declara o computed `itemCount` (número, ou `null` quando
 * não faz sentido contar). A cada mudança — carga inicial, inclusão, exclusão
 * — o card emite `item-count`, e a página atualiza o cabeçalho da caixa.
 */
export default {
  watch: {
    itemCount: {
      immediate: true,
      handler(n) {
        this.$emit("item-count", n);
      },
    },
  },
};
